import { useEffect } from "react";
import { SecretaryLayout } from "../Layout";
import {
  NumberOfPatientsChart,
  NumberOfDoctorsChart,
  NumberOfSurgeryRoomsChart,
  NumberOfPatientSurgeriesChart,
  SurgeryRoomGroupsChart,
  UsersByRoleChart,
  AvailabilityProcedureEventsChart,
  AvailabilityValorationEventsChart,
  AverageSchedulingCompletionChart,
  PatientRepeatRegistrationsChart,
  ProcedureCancellationsChart,
  ValorationCancellationsChart,
  HyperbaricChamberSessionsChart,
  QuestionSatisfactionChart,
} from "../components/dashboard";
import { PatientSurgeryChartsCard } from "../components/cards";
import { useSelectOptionsStore } from "../hooks";

export const DashboardPage = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    proceduresParent,
    satisfactionQuestions,

    // Methods
    startGetProceduresParent,
    startGetSatisfactionQuestions,
  } = useSelectOptionsStore();

  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (proceduresParent.data.length === 0) {
      startGetProceduresParent();
    }
  }, [proceduresParent.data]);

  useEffect(() => {
    if (satisfactionQuestions.data.length === 0) {
      startGetSatisfactionQuestions();
    }
  }, [satisfactionQuestions.data]);

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <h1 className="mb-2">Dashboard</h1>
          {/* Nuevas graficas */}
          <div className="row gy-4">
            <div className="col-12 col-sm-6 col-md-3">
              <NumberOfPatientsChart />
            </div>

            <div className="col-12 col-sm-6 col-md-3">
              <NumberOfDoctorsChart />
            </div>

            <div className="col-12 col-sm-6 col-md-3">
              <NumberOfSurgeryRoomsChart />
            </div>

            <div className="col-12 col-sm-6 col-md-3">
              <NumberOfPatientSurgeriesChart />
            </div>

            <div className="col-12">
              <PatientSurgeryChartsCard />
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 mt-4">
              <SurgeryRoomGroupsChart />
            </div>

            <div className="col-xl-4 mt-4">
              <UsersByRoleChart />
            </div>

            <div className="col-xl-6 mt-4">
              <AvailabilityProcedureEventsChart />
            </div>

            <div className="col-xl-6 mt-4">
              <AvailabilityValorationEventsChart />
            </div>

            <div className="col-xl-6 mt-4">
              <AverageSchedulingCompletionChart />
            </div>

            <div className="col-xl-6 mt-4">
              <PatientRepeatRegistrationsChart />
            </div>

            <div className="col-xl-6 mt-4">
              <ProcedureCancellationsChart />
            </div>

            <div className="col-xl-6 mt-4">
              <ValorationCancellationsChart />
            </div>

            <div className="col-xl-6 mt-4">
              <HyperbaricChamberSessionsChart />
            </div>

            <div className="col-12 mt-4">
              <QuestionSatisfactionChart />
            </div>
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
